module.exports = __webpack_public_path__ + "static/img/image019.03bfd54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image019.png
// module id = N/La
// module chunks = 1